import { ReactNode } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { History, GitMerge, Users, Sparkles, Activity, BookOpen } from 'lucide-react';

export function AdminLayout({ children }: { children?: ReactNode }) {
  return (
    <div>
      <div style={{ borderBottom: '1px solid var(--glass-border)', background: 'var(--glass-bg)' }}>
        <div className="max-w-7xl mx-auto px-6 flex items-center gap-1 text-sm">
          <SubNavLink to="/admin/corporate-actions"
                      icon={<GitMerge className="w-4 h-4" />}
                      label="Corporate Actions" />
          <SubNavLink to="/admin/users"
                      icon={<Users className="w-4 h-4" />}
                      label="Users" />
          <SubNavLink to="/admin/prompts"
                      icon={<Sparkles className="w-4 h-4" />}
                      label="Prompts" />
          <SubNavLink to="/admin/recon-logic"
                      icon={<BookOpen className="w-4 h-4" />}
                      label="Recon Logic" />
          <SubNavLink to="/admin/diagnostics"
                      icon={<Activity className="w-4 h-4" />}
                      label="Diagnostics" />
          <SubNavLink to="/admin/audit"
                      icon={<History className="w-4 h-4" />}
                      label="Audit Log" />
        </div>
      </div>
      {children ?? <Outlet />}
    </div>
  );
}

function SubNavLink({ to, icon, label }: { to: string; icon: ReactNode; label: string }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `px-3 py-2.5 inline-flex items-center gap-2 border-b-2 transition ${
          isActive
            ? 'font-medium'
            : 'border-transparent text-ink-400 hover:text-ink-strong'
        }`
      }
      style={({ isActive }) => isActive ? {
        borderColor: 'var(--accent)',
        color: 'var(--accent)',
      } : undefined}
    >
      {icon}{label}
    </NavLink>
  );
}
